import React, {useState, useRef} from 'react';
import {Overlay} from 'react-bootstrap';
import UserAvatar from './UserAvatar';

interface userProfileProps {
    accountName: string,
    email: string,
    signOut: () => void,
}

function UserProfile(props: userProfileProps) {
    const {email, accountName, signOut} = props;
    const [
        showMenu,
        setShowMenu,
    ] = useState<boolean>(false);
    const targetRef = useRef(null);

    const handleShowMenu = (value: boolean) => {
        setShowMenu(value);
    };

    const renderContent = () => {
        return (
            <div className="topbar-profile-menu">
                <UserAvatar name={accountName} email={email}/>
                <span className="topbar-menu-item"
                    onClick={signOut}>Sign out</span>
            </div>
        );
    }
    return (
        <>
            <div
                ref={targetRef}
                onClick={() => handleShowMenu(!showMenu)} className='manage-user-menu-trigger w-auto gap-1'
            >
                <UserAvatar
                    name={accountName} email={email} hideAvatarDetail={true}/>
                <div className="topbar-profile-toggle">
                    <span className="topbar-arrow"></span>
                </div>
            </div>
            <Overlay
                target={targetRef.current}
                show={showMenu}
                rootClose={true}
                placement='bottom'
                rootCloseEvent='mousedown'
                onHide={() => handleShowMenu(false)}
            >
                {({
                    placement: _placement,
                    arrowProps: _arrowProps,
                    show: _show,
                    popper: _popper,
                    hasDoneInitialMeasure: _hasDoneInitialMeasure,
                    ...props
                }) => (
                    <div {...props}>
                        {renderContent()}
                    </div>
                )}
            </Overlay>
        </>
    );
}

export default UserProfile;
